var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-footer',[_c('div',[_c('subtitle',[_vm._v(_vm._s(_vm.footer.tagline))])],1),_c('icon-container',_vm._l((_vm.footer.links),function(link,index){return _c('icons',{key:`product-description-${index}`,attrs:{"href":link.url,"target":"_blank"}},[_c('i',{class:link.fa})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }